const STORAGE_KEYS = {
    COOKIE_NOTIFICATION: 'cookieNotification',
    ITEMS_CLICK: 'items-click',
    SAVE_SEARCH_HINT: 'save-search-tooltip',
    SHARE_WISHLIST_TOOLTIP: 'share-wishlist-tooltip',
    SHARE_WISHLIST_TOOLTIP_SANTA: 'share-wishlist-tooltip-santa',
    SAVED_SEARCHES: 'saved-searches',
    SEARCH_RECENT: 'search-recent',
    RECENT_BRAND_ATTRIBUTES: 'recent-brand-attributes',
    WEB_PUSH_ACCEPTED: 'web_push_accepted',
    WEB_PUSH_SHOWN_MODALS: 'webPushModalsShown',
    SELLER_LIST_COMPACT_VIEW: 'sellerListCompactView',
    SYI_NEW_LAYOUT_INFO_DISMISSED: 'syiNewLayoutInfoDismissed',
    SYI_RESELL_SHOWN_FOR_DRAFT_IDS: 'syiResellShownForDraftIds',
    SYI_RESELL_ITEM_SHOWN_FOR_DRAFT_IDS: 'syiResellItemShownForDraftIds',
    SHIPPING_CONFIRMATION_PAGE_DIGITAL_STAMP_MODAL_DISMISSED_COUNT:
        'shippingConfirmationPageDigitalStampModalDismissedCount',
    SELLER_LIST_MARK_AS_SENT_HINT: 'seller-list-mark-as-sent-tooltip',
    WISHLIST_BADGE_DATE_SHOWN: 'wishlist-badge-date-shown',
    ONBOARD_BUYER_CATEGORIES: 'onboard-buyer-categories',
    ONBOARD_SELLER_CLOSED: 'onboard-seller-closed',
    FEATURE_MODAL_MAO_ACTIVE: 'featureModalMaoActive',
    FEATURE_MODAL_MGM_ACTIVE: 'featureModalMgmActive',
    // State caches
    // NOTE: Even if these keys aren't used, we check for the values which are defined in utils/cache.js so don't remove these even if they looked unused
    CACHE_MESSAGING_BADGES: 'cache.messagingBadges',
    CACHE_SYSTEM_MESSAGES: 'cache.systemMessages',
    CACHE_SYSTEM_BADGE: 'cache.systemBadges',
    // Apple ID login user
    APPLE_ID_USER: 'appleId.user',

    USER_PROFILE: 'tradera--user-profile',
    HAS_SHOWED_MFA_VERIFICATION_MESSAGE: 'hasShowedMfaVerification'
};

const STORAGE_VALUES = {
    SAVE_SEARCH_HINT_CLICKED: 'CLOSE_CLICKED',
    SHARE_WISHLIST_TOOLTIP_CLICKED: 'CLOSE_CLICKED',
    SHARE_WISHLIST_TOOLTIP_SANTA_CLICKED: 'CLOSE_CLICKED',
    SELLER_LIST_MARK_AS_SENT_HINT_CLICKED: 'CLOSE_CLICKED',
    FEATURE_MODAL_MAO_DISMISSED_CLICKED: 'CLOSE_CLICKED',
    FEATURE_MODAL_MGM_DISMISSED_CLICKED: 'CLOSE_CLICKED',
    ONBOARD_SELLER_CLOSED_CLICKED: 'CLOSE_CLICKED'
};

export { STORAGE_KEYS, STORAGE_VALUES };
